/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetGipReportExportStatusQueryResponse, GetGipReportExportStatusPathParams, GetGipReportExportStatus404 } from "../models/GetGipReportExportStatus";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getGipReportExportStatus } from "../axios/getGipReportExportStatus";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getGipReportExportStatusQueryKey = (id: GetGipReportExportStatusPathParams["id"]) => ["audit-reports-api", { url: '/reports/gip/report/:id/export-status', params: {id:id} }] as const

export type GetGipReportExportStatusQueryKey = ReturnType<typeof getGipReportExportStatusQueryKey>

export function getGipReportExportStatusQueryOptions(id: GetGipReportExportStatusPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getGipReportExportStatusQueryKey(id)
        return queryOptions<GetGipReportExportStatusQueryResponse, ResponseErrorConfig<GetGipReportExportStatus404>, GetGipReportExportStatusQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getGipReportExportStatus(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get export job status for report
 * {@link /reports/gip/report/:id/export-status}
 */
export function useGetGipReportExportStatus<TData = GetGipReportExportStatusQueryResponse, TQueryData = GetGipReportExportStatusQueryResponse, TQueryKey extends QueryKey = GetGipReportExportStatusQueryKey>(id: GetGipReportExportStatusPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<GetGipReportExportStatusQueryResponse, ResponseErrorConfig<GetGipReportExportStatus404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getGipReportExportStatusQueryKey(id)
         

         const query = useQuery({
          ...getGipReportExportStatusQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetGipReportExportStatus404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}